"use strict";

const Event = require("./../lib/events");

class Slider {
    constructor() {
        this.brands();
        this.instagram();
        this.keyVisual();
        this.products();
    }

    instagram() {
        let instagramPosts = document.querySelectorAll(".ce-instagram");

        if (instagramPosts.length > 0) {
            //  Require module only if there is a Media slider requested
            const Swiper = require("./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js");

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of instagramPosts) {
                let swiper = new Swiper(
                    slider.querySelector(".swiper-container"),
                    {
                        init: false,
                        centeredSlides: true,
                        speed: 800,
                        simulateTouch: true,
                        spaceBetween: 24,
                        slidesPerView: 4,
                        watchOverflow: true,
                        navigation: {
                            nextEl: slider.querySelector(".next-slide"),
                            prevEl: slider.querySelector(".prev-slide"),
                        },
                        pagination: {
                            el: slider.querySelector(".swiper-pagination"),
                            type: "progressbar",
                        },
                        breakpoints: {
                            1024: {
                                slidesPerView: 2,
                                spaceBetween: 24,
                            },
                            768: {
                                spaceBetween: 16,
                                slidesPerView: 1.3,
                                slidesOffsetBefore: -32,
                            },
                            375: {
                                spaceBetween: 16,
                                slidesPerView: 1.3,
                                slidesOffsetBefore: -24,
                            },
                        },
                    }
                );

                swiper.on("init", function () {
                    setTimeout(function () {
                        App.Globals.$window.trigger("calculate:squares");
                    }, 500);
                });

                swiper.init();
            }
        }
    }

    products() {
        let products = document.querySelectorAll(".ce-product-slider");

        if (products.length > 0) {
            //  Require module only if there is a Media slider requested
            const Swiper = require("./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js");

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of products) {
                new Swiper(slider.querySelector(".swiper-container"), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 3,
                    watchOverflow: true,
                    navigation: {
                        nextEl: slider.querySelector(".next-slide"),
                        prevEl: slider.querySelector(".prev-slide"),
                    },
                    pagination: {
                        el: slider.querySelector(".swiper-pagination"),
                        type: "progressbar",
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        768: {
                            spaceBetween: 16,
                            slidesPerView: 1,
                        },
                    },
                });
            }
        }
    }

    doorways() {
        let products = document.querySelectorAll(".ce-doorways");

        if (products.length > 0) {
            //  Require module only if there is a Media slider requested
            const Swiper = require("./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js");

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of products) {
                let sliderContainer = slider.querySelector(".swiper-container");
                let maxItems = sliderContainer.dataset.maxItems ?? 2;

                let swiper = new Swiper(
                    slider.querySelector(".swiper-container"),
                    {
                        init: false,
                        speed: 800,
                        simulateTouch: true,
                        spaceBetween: 16,
                        slidesPerView: maxItems,
                        watchOverflow: false,
                        pagination: {
                            el: slider.querySelector(".swiper-pagination"),
                            type: "progressbar",
                        },
                        breakpoints: {
                            1440: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerColumn: maxItems,
                                slidesPerGroup: maxItems,
                                slidesPerView: 1,
                            },
                        },
                    }
                );

                swiper.on("init", function () {
                    setTimeout(function () {
                        Event.trigger(window, "resize");
                    }, 300);
                });

                swiper.init();
            }
        }
    }

    brands() {
        let brands = document.querySelectorAll(".ce-brands");

        if (brands.length > 0) {
            //  Require module only if there is a Media slider requested
            const Swiper = require("./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js");

            //  Because this is a Content Element, this element can be used multiple times on a page.
            //  If you don't loop through each slider, the controls will be sliding all the Swipers of this type on the page.
            for (let slider of brands) {
                new Swiper(slider.querySelector(".swiper-container"), {
                    speed: 800,
                    simulateTouch: true,
                    spaceBetween: 24,
                    slidesPerView: 3,
                    watchOverflow: true,
                    pagination: {
                        el: slider.querySelector(".swiper-pagination"),
                        type: "progressbar",
                    },
                    breakpoints: {
                        540: {
                            spaceBetween: 16,
                            slidesPerView: 1,
                        },
                    },
                });
            }
        }
    }

    keyVisual() {
        let keyVisual = document.querySelectorAll(".keyvisual");

        if (keyVisual.length > 0) {
            let autoSlide = keyVisual[0].dataset.autoSlide === "1";

            //  Require module only if there is a Media slider requested
            const Swiper = require("./../../../../build/node_modules/@components/swiper/dist/js/swiper.min.js");

            new Swiper(keyVisual[0].querySelector(".swiper-container"), {
                speed: 800,
                simulateTouch: false,
                slidesPerView: 1,
                watchOverflow: true,
                autoplay: autoSlide,
                loop: false,
                navigation: {
                    nextEl: keyVisual[0].querySelector(".next-slide"),
                    prevEl: keyVisual[0].querySelector(".prev-slide"),
                },
                pagination: {
                    clickable: true,
                    el: keyVisual[0].querySelector(".swiper-pagination"),
                    type: "bullets",
                },
                preloadImages: false,
                roundLengths: true,
                breakpoints: {
                    1024: {
                        simulateTouch: true,
                    },
                },
                on: {
                    slideChange: function () {
                        let videos = document.querySelectorAll("video");

                        if (videos.length > 0) {
                            for (let i = 0; i < videos.length; i++) {
                                let video = videos[i];
                                let parentMediaHolder =
                                    video.closest(".media-holder");

                                //  Stops video
                                video.pause();

                                //  Remove classNames from media holder
                                if (parentMediaHolder) {
                                    parentMediaHolder.classList.remove(
                                        "is-playing"
                                    );
                                }
                            }
                        }
                    },
                },
            });
        }
    }
}

module.exports = Slider;
